<template>
  <div class="WxLogin-contaniner">
    <div id="wxlogin" class="login"></div>
  </div>
</template>

<script>
export default {
  name: 'WxLogin',
  data() {
    return {
    }
  },
  created() {
    window.redirectCallback = str => {
      let code = this.$utils.getURLParam('code', str)
      let state = this.$utils.getURLParam('state', str)
      // console.log(str)
      this.$emit('login', { code, state })
    }
  },
  mounted() {
    this.initWechatLogin()
  },
  methods: {
    initWechatLogin() {
      // let ba64Css = 'css代码base64编码' // 微信需要https的样式路径，这里将样式内容加密base64，可以避免使用https，如果你的网站是https的可以直接使用安官方文档使用css文件路径
      const appid = 'wxd7cd8ef7d5a4b702'

      const redirectUri = encodeURIComponent(location.origin + '/static/redirect.html')

      // 获取二维码
      // eslint-disable-next-line no-undef
      return new WxLogin({
        id: 'wxlogin', //div的id
        appid,
        self_redirect: true, // 是否在iframe内跳转，默认false
        scope: 'snsapi_login', //固定内容
        redirect_uri: redirectUri, //回调地址
        // href: "http://*/static/UserCss/WeChart.css" //自定义样式链接，第三方可根据实际需求覆盖默认样式。
        // href: "data:text/css;base64," + ba64Css
        // state: "", //参数，可带可不带
        style: 'black' //样式  提供"black"、"white"可选，默认为黑色文字描述
      })
    }
  }
}
</script>

<style scoped lang="less">
.WxLogin-contaniner {
  padding-top: 30px;
}
</style>
